import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "all-kits-popover" }
const _hoisted_2 = { class: "t2 -t_medium" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "t2 -t_medium" }

import { computed } from 'vue'
import { $date } from '@/plugins'
import { PILL_STATUS_TYPES } from '@/components/micro/Pills/BasePill/base-pill.types'
import type { Kit } from '@/components/drawers/MemberDrawer/types/member-drawer.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'AllMemberKits',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props

const itemsParsed = computed(() => props.items?.map((item) => ({
  ...item,
  updated_at: item.updated_at ? $date(item.updated_at).format('MMM D, YYYY, HH:mm') : '-',
})) || [])

return (_ctx: any,_cache: any) => {
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!
  const _component_base_pill = _resolveComponent("base-pill")!
  const _component_sword_popover_wuk = _resolveComponent("sword-popover-wuk")!

  return (_openBlock(), _createBlock(_component_sword_popover_wuk, {
    class: "all-kits",
    distance: 10,
    placement: "bottom-end"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('SIDEBAR.KIT')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('PATIENTS.STATUS')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('COMMON.LAST_UPDATE')), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsParsed.value, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: itemIndex,
            class: "kit-item"
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(item.product_type)), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_pill, {
                type: _unref(PILL_STATUS_TYPES).KIT,
                status: item.status
              }, null, 8, ["type", "status"])
            ]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.updated_at), 1)
          ]))
        }), 128))
      ])
    ]),
    default: _withCtx(() => [
      (__props.items.length)
        ? (_openBlock(), _createBlock(_component_sword_button_wuk, {
            key: 0,
            theme: "secondary",
            icon: "box",
            size: "small",
            side: "left",
            text: "button.all_kits",
            class: "-mx_0"
          }))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}
}

})